module.exports = __webpack_public_path__ + "img/icon-thumbs-up.c5156929.svg";